// Generated by purs version 0.15.15
import * as Data_Argonaut_Decode_Generic from "../Data.Argonaut.Decode.Generic/index.js";
import * as Data_Argonaut_Encode_Generic from "../Data.Argonaut.Encode.Generic/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as MST_Encoding from "../MST.Encoding/index.js";
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var DownloadIsSymbol = {
    reflectSymbol: function () {
        return "Download";
    }
};
var UploadIsSymbol = {
    reflectSymbol: function () {
        return "Upload";
    }
};
var PingIsSymbol = {
    reflectSymbol: function () {
        return "Ping";
    }
};
var Download = /* #__PURE__ */ (function () {
    function Download() {

    };
    Download.value = new Download();
    return Download;
})();
var Upload = /* #__PURE__ */ (function () {
    function Upload() {

    };
    Upload.value = new Upload();
    return Upload;
})();
var Ping = /* #__PURE__ */ (function () {
    function Ping() {

    };
    Ping.value = new Ping();
    return Ping;
})();
var genericMeasurement_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Download.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Upload.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return Ping.value;
        };
        throw new Error("Failed pattern match at Fusion.Data.Measurement (line 15, column 1 - line 15, column 38): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Download) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Upload) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Ping) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at Fusion.Data.Measurement (line 15, column 1 - line 15, column 38): " + [ x.constructor.name ]);
    }
};
var showMeasurement = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericMeasurement_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(DownloadIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(UploadIsSymbol))(/* #__PURE__ */ genericShowConstructor(PingIsSymbol))))
};
var eqMeasurement = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Download && y instanceof Download) {
                return true;
            };
            if (x instanceof Upload && y instanceof Upload) {
                return true;
            };
            if (x instanceof Ping && y instanceof Ping) {
                return true;
            };
            return false;
        };
    }
};
var encodeJsonMeasurement = {
    encodeJson: /* #__PURE__ */ MST_Encoding.genericEncodeJsonVisonum(genericMeasurement_)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(DownloadIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(UploadIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(PingIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))))
};
var decodeJsonMeasurement = {
    decodeJson: /* #__PURE__ */ MST_Encoding.genericDecodeJsonVisonum(genericMeasurement_)(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(DownloadIsSymbol))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(UploadIsSymbol))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(PingIsSymbol))))
};
export {
    Download,
    Upload,
    Ping,
    genericMeasurement_,
    eqMeasurement,
    showMeasurement,
    encodeJsonMeasurement,
    decodeJsonMeasurement
};
//# sourceMappingURL=index.js.map
